import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';
import {RoutingService} from '@app/service/routing/routing.service';
import {interceptorConstants} from '@shared/interfaces';
import {from} from 'rxjs';
import {getAuth} from '@angular/fire/auth';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  errorCount = 0;

  constructor(private routingService: RoutingService) {
  }

  /**
   * For every request, add a bearer token for server side authentication and handle errors that are returned by API
   * @param request
   * @param next
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const currentUser = getAuth().currentUser;
    if (!currentUser) {
      return next.handle(request);
    }
    // Get Auth Token that is saved for a user and make sure the request is to project specific api
    return from(currentUser.getIdToken())
      .pipe(mergeMap((token: string) => {
        if (token) {
          let authReq = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*'
            }
          });
          if (authReq.body) {
            authReq = authReq.clone({
              body: {...authReq.body}
            });
          }

          // Pass on the cloned request instead of the original request and catch any errors
          return next.handle(authReq).pipe(catchError((error) => {
            if (error.status === interceptorConstants.UNAUTHORIZED) {
              // logout users, redirect to login page
              // this.store.dispatch(new Logout());
            }

            // this.logger.error('error------>', error);

            if (error.status === interceptorConstants.PRECONDITION_FAILED) {
              // Reloading the page should fix the issue when no resource found
              location.reload();
            }

            if (error.status === interceptorConstants.INTERNAL_ERROR || error.status === interceptorConstants.GATEWAY_TIMEOUT) {
              if (this.errorCount < interceptorConstants.MAXIMUM_RE_REQUEST_LIMIT) {
                this.errorCount++;
                return next.handle(authReq);
              } else {
                this.routingService.navigateHome();
              }
            }

            // return all others errors
            return throwError(error);

          })) as any;
        } else {
          return next.handle(request);
        }
      }));
  }
}
